// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';
import axios from 'axios';

class SessionServiceInterface {
  constructor() {
    this.service_id = 'sessionservice-1_0';
  }

  // SessionRequest, Response: Session
  // sessionId: int
  getSession(sessionId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SessionRequest', { sessionId: sessionId }, success_callback);
  }

  // StoreDataSetAction, Response: Boolean
  // sessionId: int
  // dataSetName: String
  storeDataSet(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'StoreDataSetAction', request, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // project_id: int
  subscribeToSessionList(project_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/list/' + project_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/list/' + project_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // AddSessionResourceAction, Response: AddSessionResourceResponse
  // sessionId: Integer
  // contentType: String
  addSessionResource(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AddSessionResourceAction', request, success_callback);
  }

  addSessionResourceFile(session_id, file, type) {
    if (type == null) type = file.type;
    return this.addSessionResource({ sessionId: session_id, contentType: type }).then(response => {
      var upload_url = response.putURL;

      var options = {
        headers: {
          'Content-Type': type
        }
      };
      if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
        //axios seems to set the content type automatically, but on IE11 it does not clear what is set before. So content type is something like 'image/png, image/png' and that makes the aws signature invalid
        options.headers['Content-Type'] = '';
      }
      return axios.put(upload_url, file, options).then(put_resp => {
        return response.resourceId;
      });
    });
  }
}

export const sessionService = new SessionServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/sessionservice.js
// module id = UF6c
// module chunks = 1 2 3 4 5 6